import { EmptyState } from '@cinesend/ui-kit'
import DataTable from '../data_table'
import AppDialog from '../app_dialog'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import axios from 'axios'
import { useQueryClient } from '@tanstack/react-query'
import useTableFilters from '../../hooks/use_table_filters'

const RecallModal = ({ label, onClose, id, currentAssetsQueryKey, recallableAssetsQueryKey }) => {
  const [selectedIDs, setSelectedIDs] = useState([])
  const queryClient = useQueryClient()
  const recallAsset = useMutation(
    () => {
      return axios.post(`/cycles/${id}/recall-asset`, { recalled_assets: selectedIDs })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(currentAssetsQueryKey)
        onClose()
      },
    }
  )
  const { queryString, searching } = useTableFilters({
    enableSearch: true,
    queryExists: true,
  })
  const { data: recallableAssets, isLoading, error, refetch } = useQuery([recallableAssetsQueryKey, queryString])

  const columns = [{ key: 'title', header: 'Title', render: (data) => data.title }]

  return (
    <AppDialog
      title={`Recall ${String(label || '').toLowerCase()}`}
      onClose={onClose}
      size='lg'
      confirmText='Recall'
      onConfirm={() => recallAsset.mutate()}
      confirmDisabled={selectedIDs.length === 0}
    >
      <DataTable
        caption='Recallable assets'
        columns={columns}
        rows={recallableAssets ?? []}
        rowKey={(data) => String(data.latest_version_id)}
        isLoading={isLoading}
        error={error}
        onRetry={refetch}
        empty={<EmptyState title='No assets to recall' />}
        searching={searching}
        selectedKeys={selectedIDs.map(String)}
        onSelectionChange={(keys) =>
          setSelectedIDs(
            recallableAssets
              .filter((data) => keys.includes(String(data.latest_version_id)))
              .map((data) => data.latest_version_id)
          )
        }
        selectionLabel={(data) => `Recall ${data.title}`}
      />
    </AppDialog>
  )
}

export default RecallModal
